import { PickingValidateSkuDetail } from '../../interfaces/Picking/Picking'
import {
  SET_MESSAGE_STATUS,
  SET_MESSAGE_COLOR,
  SWITCH_SNACKBAR,
  SWITCH_MODAL,
  SET_PICKING_ROUTE_ID,
  SET_ROWS_PICKING_VALIDATE,
  SHOW_MODAL_REPORT_DIFF,
  SET_IS_LOADING_GRID,
  SET_BTN_FILTER,
  SET_LOADING_PRINT,
  SET_PICKING_VALIDATE_PDF,
  SET_TOTAL_ITEMS,
  CHANGE_PAGE,
  CHANGE_PAGE_SIZE,
  SET_SKU_ID,
  SET_LOADING_BUTTON,
  SHOW_ALERT
} from './PickingValidateActionTypes'

export type PickingRouteIdAction =
  | SetSkuId
  | PickingRouteIdEvent
  | SetMessageStatus
  | SetMessageColor
  | SetSwitchSnackbar
  | SetSwitchModal
  | SetRowsPickingValidate
  | SetIsLoadingGrid
  | SetLoadingPrint
  | SetPickingValidatePDF
  | SetTotalItems
  | ChangePage
  | ChangePageSize

export interface SetSkuId {
  type: typeof SET_SKU_ID
  payload: string
}

export interface PickingRouteIdEvent {
  type: typeof SET_PICKING_ROUTE_ID
  payload: number
}

export interface SetMessageStatus {
  type: typeof SET_MESSAGE_STATUS
  payload: string
}

export interface SetMessageColor {
  type: typeof SET_MESSAGE_COLOR
  payload: string
}

export interface SetSwitchSnackbar {
  type: typeof SWITCH_SNACKBAR
  payload: boolean
}

export interface SetSwitchModal {
  type: typeof SWITCH_MODAL
  payload: boolean
}

export interface ShowAlert {
  type: typeof SHOW_ALERT
  payload: boolean
}

export interface SetRowsPickingValidate {
  type: typeof SET_ROWS_PICKING_VALIDATE
  payload: PickingValidateSkuDetail[]
}

export interface ShowModalReportDiff {
  type: typeof SHOW_MODAL_REPORT_DIFF
  payload: boolean
}

export interface SetIsLoadingGrid {
  type: typeof SET_IS_LOADING_GRID
  payload: boolean
}

export interface SetBtnFilter {
  type: typeof SET_BTN_FILTER
  payload: string
}

export interface SetLoadingPrint {
  type: typeof SET_LOADING_PRINT
  payload: boolean
}

export interface SetPickingValidatePDF {
  type: typeof SET_PICKING_VALIDATE_PDF
  payload: string
}

export interface SetTotalItems {
  type: typeof SET_TOTAL_ITEMS
  payload: number
}

export interface ChangePage {
  type: typeof CHANGE_PAGE
  payload: number
}

export interface ChangePageSize {
  type: typeof CHANGE_PAGE_SIZE
  payload: number
}

export interface SetLoadingButton {
  type: typeof SET_LOADING_BUTTON
  payload: boolean
}

export const setSkuIdAction = (skuId: string): SetSkuId => {
  return {
    type: SET_SKU_ID,
    payload: skuId
  }
}

export const setPickingRouteIdAction = (
  pickingRouteId: number
): PickingRouteIdEvent => {
  return {
    type: SET_PICKING_ROUTE_ID,
    payload: pickingRouteId
  }
}

export const setMessageStatus = (mensaje: string): SetMessageStatus => {
  return {
    type: SET_MESSAGE_STATUS,
    payload: mensaje
  }
}

export const setMessageColor = (tipoMensaje: string): SetMessageColor => {
  return {
    type: SET_MESSAGE_COLOR,
    payload: tipoMensaje
  }
}

export const setSwitchSnackBar = (
  switchSnackBar: boolean
): SetSwitchSnackbar => {
  return {
    type: SWITCH_SNACKBAR,
    payload: switchSnackBar
  }
}

export const setSwitchModal = (switchModal: boolean): SetSwitchModal => {
  return {
    type: SWITCH_MODAL,
    payload: switchModal
  }
}

export const showAlertAction = (showAlert: boolean): ShowAlert => {
  return {
    type: SHOW_ALERT,
    payload: showAlert
  }
}

export const setLoadingButton = (
  isLoadingButton: boolean
): SetLoadingButton => {
  return {
    type: SET_LOADING_BUTTON,
    payload: isLoadingButton
  }
}

export const setRowsPickingRouteValidate = (
  rows: PickingValidateSkuDetail[]
): SetRowsPickingValidate => {
  return {
    type: SET_ROWS_PICKING_VALIDATE,
    payload: rows
  }
}

export const setShowModalReportDiff = (
  showModalReportDiff: boolean
): ShowModalReportDiff => {
  return {
    type: SHOW_MODAL_REPORT_DIFF,
    payload: showModalReportDiff
  }
}

export const setIsLoadingGrid = (isLoadingGrid: boolean): SetIsLoadingGrid => {
  return { type: SET_IS_LOADING_GRID, payload: isLoadingGrid }
}

export const setBtnFilter = (btnFilter: string): SetBtnFilter => {
  return { type: SET_BTN_FILTER, payload: btnFilter }
}

export const setLoadingPrint = (isLoadingPrint: boolean): SetLoadingPrint => {
  return {
    type: SET_LOADING_PRINT,
    payload: isLoadingPrint
  }
}

export const setPickingValidatePDF = (
  pickingValidatePDF: string
): SetPickingValidatePDF => {
  return { type: SET_PICKING_VALIDATE_PDF, payload: pickingValidatePDF }
}

export const setTotalItems = (totalItems: number): SetTotalItems => {
  return {
    type: SET_TOTAL_ITEMS,
    payload: totalItems
  }
}

export const changePage = (page: number): ChangePage => {
  return {
    type: CHANGE_PAGE,
    payload: page
  }
}

export const changePageSize = (rowsPerPage: number): ChangePageSize => {
  return {
    type: CHANGE_PAGE_SIZE,
    payload: rowsPerPage
  }
}
